export interface StatusMessageProps {
  children: React.ReactNode;
  tone: 'pending' | 'success' | 'error';
  className?: string;
}

const toneClassNames = {
  pending: 'border-line bg-paper-soft text-ink-soft',
  success: 'border-sage/40 bg-sage/10 text-sage',
  error: 'border-clay/40 bg-clay/10 text-clay',
} as const;

export function StatusMessage({
  children,
  tone,
  className,
}: StatusMessageProps): React.ReactElement {
  const role = tone === 'error' ? 'alert' : 'status';

  return (
    <p
      role={role}
      className={classNames(
        'rounded-xl border px-4 py-2.5 text-sm font-medium',
        toneClassNames[tone],
        className,
      )}
    >
      {children}
    </p>
  );
}

function classNames(...values: Array<string | undefined>): string {
  return values.filter(Boolean).join(' ');
}
